/* Vanilla JS replacement for the jQuery .ite_row/.modal pattern from v3.6 theme.liquid. */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.ite_row').forEach(function(row) {
    row.addEventListener('click', function() {
      document.querySelectorAll('.modal').forEach(function(m) {
        m.style.display = 'none';
        m.classList.remove('hide');
      });
      var modal = row.parentElement.querySelector('#myModal');
      if (modal) modal.style.display = '';
    });
  });

  document.querySelectorAll('.close').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.modal').forEach(function(m) {
        m.classList.add('hide');
      });
    });
  });
});
